export const GET_ONE_PRODUCT = "ONE_PRODUCT";
export const MERCHANTS_LISTING = "MERCHANTS_LISTING";
export const CATEGORY_LISTING = "CATEGORY_LISTING";
export const BRANDS_LISTING = "BRANDS_LISTING";
